<template>
    <div class="code-view">
        <div class="wrapper"></div>
        <div class="header"></div>

        <el-form label-width="120px">

            <el-form-item label="战队码：">
                <el-input v-model="team" class="code-input"></el-input>
                <el-button class="u-btn search" @click="search_handle">搜索</el-button>
            </el-form-item>

            <el-form-item label="战队名：">
                <el-input v-model="team_name" class="code-input" :readonly="true" :disabled="true"></el-input>
            </el-form-item>            

        </el-form>        

        <!-- <el-input 
        class="code-input" 
        v-model="team" 
        placeholder="输入队伍码确认加入参赛战队" 
        ref="code_input"
        :readonly="next"
        label="战队码"
        ></el-input> -->
               
        <div class="u-btn join" v-if="next" @click="join_team"></div>
        <div class="u-btn join" v-else></div>
    </div>  
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        team : '',
        team_name : '',
        next : false,
        loading: false,
        tid : '',
      };
    },
    props : {
        ua : {
            default : ()=>{},
        }
    },
    watch: {
        dialogVisible (newVal) {
            if (newVal) {
                setTimeout(()=>{
                    this.$refs.code_input.focus();
                },10)
            }
            else{
                //TODO
                this.next = false;
                this.team = '';
            }
        }
    },    
    methods: {
      handleClose(done) {
          this.$destroy();
      },
      search_handle() {
          var self = this;
          //this.$emit('destory_all', ['inner_code']);
          //this.next = true;
          if(!this.team)return this.$message.error('请填写战队码');
          
          this.$axios.get(this.$ajax_url_map.code,{
              params : {
                  code : this.team,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  this.next = true;
                  this.team_name = res.data.data.name;
                  this.tid = res.data.data.id;
              }
              else{
                this.$message.error(res.data.message);  
              }
          })
      },
      join_team (){

          let self = this;

          this.$axios.get(this.$ajax_url_map.playInfo,{
              params : {
                  teamId: this.tid,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  //success
                self.$emit('destory_all',['inner']);
                self.$join_modal({
                    ua : self.ua,
                    id : self.tid,
                    playerData : {
                        "id": res.data.data.id,  //玩家ID
                        "account":res.data.data.account,  //玩家数字ID
                        "nick": res.data.data.nick,  //昵称
                    },
                });

              }
              else{            
                  this.$message.error(res.data.message);
              }
          });
      },         
    }
  };
</script>

<style scoped>

    .code-view{
        position: relative;
        width: 450px;
        height: 298px;
        margin: 5px auto;
        z-index: 2;       
    }

    .wrapper{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/wrapper-hint.png);
        z-index: 2;
        pointer-events: none;       
    }

    .header{
        width: 447px;
        height: 45px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/header-code.png);
    }    

    .code-input{
        width: 220px;
        /* text-align: center; */
    }

    .u-btn.search{
        display: inline-block;
        width: 52px;
        height: 31px;
        margin-left: 3px;
        background-image: url(~@/assets/images/btn-search.png);
        color: transparent;
        font-size: 0;
        vertical-align: super;
    }

    .u-btn.join{
        width: 264px;
        height: 67px;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-join.png);
        color: transparent;
        font-size: 0;
    } 

</style>

<style>
    .code-input .el-input__inner{
        /* text-align: center; */
    }
</style>


// WEBPACK FOOTER //
// src/components/codeModal/codeModal.vue